import {
  createMultiStyleConfigHelpers,
  type MultiStyleType,
  type StyleThemingProps,
} from './styleHelpers'
import { mergeMultiStyleConfig } from './styleHelpers'

export const MenuItemStyleValues = {
  defaultOuterContainerWidth: 'full',
}

const MenuItemParts = [
  'outerContainer',
  'itemContainer',
  'textContainer',
  'primaryText',
  'destructiveText',
  'secondaryText',
] as const

const helpers = createMultiStyleConfigHelpers(MenuItemParts)
export const MenuItemStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    outerContainer: {
      borderRadius: '0.5rem',
      _hover: {
        backgroundColor: 'bg.muted',
      },
      _active: {
        backgroundColor: 'bg.emphasized',
      },
      cursor: 'pointer',
    },
    itemContainer: {
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '0.5rem',
      paddingY: '0.5rem',
      paddingX: '0.75rem',
      width: 'full',
    },
    textContainer: {
      flexDirection: 'column',
      flexGrow: 1,
    },
    primaryText: {
      textStyle: 'Body1',
      lineHeight: '1.5rem',
      color: 'fg.default',
      userSelect: 'none',
    },
    destructiveText: {
      textStyle: 'Body1',
      lineHeight: '1.5rem',
      color: 'red.fg',
      userSelect: 'none',
    },
    secondaryText: {
      textStyle: 'Body2',
      color: 'fg.muted',
      userSelect: 'none',
    },
  },
})

export const useMenuItemStyles = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(MenuItemStyle, props) as MultiStyleType<
    typeof MenuItemParts
  >
}
